import React, { useState, useEffect } from "react";
import {
	Form,
	Button,
	Row,
	Col,
	Card,
	notification,
	Select,
	DatePicker,
} from "antd";
import taskService from "../../../services/tasks";
import { Navigate, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
const dateFormat = "YYYY-MM-DD HH:mm:ss";

function TaskStatus({ data, reloadData, formId }) {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [taskStatus, setTaskStatus] = useState([]);
	const [selectedTaskStatus, setSelectedTaskStatus] = useState([]);
	const [dueAtRules, setDueAtRules] = useState([{ required: false }]);
	const navigate = useNavigate();
	const { currentUser } = useSelector((state) => state.user);

	// const getTaskStatus = async (page = 1) => {
	//   setLoading(true);
	//   await taskService.getTaskStatus().then((response) => {
	//     setTaskStatus(response.data);
	//     if (data?.task_status?.id) {
	//       const defaultStatus = response.data.find(
	//         (option) => option.id === data.task_status.id
	//       );

	//       const assignedTeam = data.assigned_task?.assign_task_teams?.[0];

	//       if (defaultStatus) {
	//         setSelectedTaskStatus(defaultStatus.id);
	//         form.setFieldsValue({
	//           status: defaultStatus.id,
	//           start_at: assignedTeam?.team_start_at
	//             ? dayjs(assignedTeam.team_start_at)
	//             : null,
	//           due_at: assignedTeam?.team_due_at
	//             ? dayjs(assignedTeam.team_due_at)
	//             : null,
	//           team_id: assignedTeam?.team?.id,
	//         });
	//       }
	//     }
	//     setLoading(false);
	//   });
	// };

	const getTaskStatus = async () => {
		setLoading(true);
		try {
			const response = await taskService.getTaskStatus();
			const statusList = response.data;
			setTaskStatus(statusList);

			const assignedTeams = data?.assigned_task?.assign_task_teams || [];
			const currentUserId = currentUser?.user_id;

			const userTeam = assignedTeams.find((team) =>
				team.members?.some((member) => member.id === currentUserId)
			);

			if (userTeam) {
				const { task_status_name, team_start_at, team_due_at, team } = userTeam;

				const defaultStatus = statusList.find(
					(status) => status.id === task_status_name?.id
				);

				if (defaultStatus) {
					setSelectedTaskStatus(defaultStatus.id); // optional now
				}

				form.setFieldsValue({
					status: defaultStatus?.id || null,
					start_at: team_start_at
						? dayjs(team_start_at, "DD-MM-YYYY HH:mm:ss")
						: null,
					due_at: team_due_at
						? dayjs(team_due_at, "DD-MM-YYYY HH:mm:ss")
						: null,
					team_id: team?.id || null,
				});
			}
		} catch (error) {
			console.error("Error fetching task statuses", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getTaskStatus();
	}, []);

	const onFinish = async (values) => {
		setLoading(true);
		let dueAtValue = values.due_at?.format("YYYY-MM-DD HH:mm:ss");
		// If status is 6 or 7, send '' for due_at
		if (values.status === 6 || values.status === 7) {
			dueAtValue = "";
		} else if (!values.due_at) {
			dueAtValue = null;
		}
		const formattedValues = {
			form_id: formId,
			task_id: data.assigned_task.id,
			status: values.status,
			start_at: values.start_at?.format("YYYY-MM-DD HH:mm:ss"),
			due_at: dueAtValue,
			team_id: values.team_id,
		};

		try {
			const response = await taskService.updateTaskStatus(formattedValues);
			if (response.success) {
				notification.success({
					message: "Success",
					description: response.data?.message,
				});
				reloadData();
				navigate("/dashboard");
			}
		} catch (error) {
			notification.error({
				message: "Error",
				description: error?.response?.data?.message || "Something went wrong",
			});
		} finally {
			setLoading(false);
		}
	};

	console.log("yes here");
	console.log(currentUser);
	console.log(
		"data?.assigned_task?.assign_task_teams",
		data?.assigned_task?.assign_task_teams
	);
	console.log("yes here");

	const currentUserId = currentUser?.user_id;

	const userTeams = data?.assigned_task?.assign_task_teams?.filter((team) =>
		team.members?.some((member) => member.id === currentUserId)
	);

	return (
		<Card style={{ padding: "0", marginBottom: "4px" }}>
			<Form form={form} onFinish={onFinish} layout='vertical' className='mt-30'>
				<Row gutter={[24, 24]}>
					<Col xs={6} sm={6} md={6} lg={6} xl={6}>
						<Form.Item
							label='Status'
							name='status'
							rules={[
								{
									required: true,
									message: "Please select the status",
								},
							]}
						>
							<Select
								size='large'
								placeholder='Select Status'
								onChange={(value) => {
									// If status is 6 or 7, require due_at
									if (value === 6 || value === 7) {
										setDueAtRules([
											{
												required: true,
												message: "Please select due date & time",
											},
										]);
									} else {
										setDueAtRules([{ required: false }]);
									}
								}}
							>
								{taskStatus.map((option) => (
									<Select.Option key={option.id} value={option.id}>
										{option.name}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>
					{/* Start At */}
					<Col span={6}>
						<Form.Item
							label='Start At'
							name='start_at'
							rules={[
								{ required: true, message: "Please select start date & time" },
							]}
						>
							<DatePicker
								showTime
								format={dateFormat}
								style={{ width: "100%" }}
								size='large'
							/>
						</Form.Item>
					</Col>

					{/* Due At */}
					<Col span={6}>
						<Form.Item label='End At' name='due_at' rules={dueAtRules}>
							<DatePicker
								showTime
								format={dateFormat}
								style={{ width: "100%" }}
								size='large'
							/>
						</Form.Item>
					</Col>
					<Col xs={6} sm={6} md={6} lg={6} xl={6}>
						<Form.Item
							label='Team'
							name='team_id'
							rules={[{ required: true, message: "Please select a team" }]}
						>
							<Select size='large' placeholder='Select Team'>
								{userTeams?.map((item, index) => (
									<Select.Option key={item.team.id} value={item.team.id}>
										{item.team.name}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>

					<Col xs={24} sm={12} md={8} lg={6} xl={6}>
						<Form.Item>
							<Button
								type='primary'
								htmlType='submit'
								loading={loading}
								className='mt-20'
								size='large'
							>
								Respond to status
							</Button>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Card>
	);
}

export default TaskStatus;
